"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProviderContent = void 0;
const react_1 = __importDefault(require("react"));
const types_1 = require("../../../types");
const config_utils_1 = require("../config-utils");
const images_1 = require("../images");
const provider_1 = require("../provider");
/**
 * A type guard function used to check whether we have a provider object or custom content.
 * Asserts a type of either Provider or ProviderContent.
 *
 * @param {Provider | ProviderContent} provider the provider object or the custom content to render
 * @returns a boolean indicating whether the object was custom content to render
 */
const isProviderContent = (provider) => typeof provider.name === 'string';
/**
 * A hook for processing a provider object and extracting the content fields within.
 * If passed an object that already has the content extracted to the root of the object,
 * such as when passing custom content, it simply returns said object.
 *
 * @param {object} props the hook properties
 * @param {Provider | ProviderContent} props.provider the provider object or the custom content to render
 * @param {ProviderLocation} props.location the location of the provider
 * @param {ProviderAvailability} props.availability the availability of the provider
 * @param {PMCConfig} props.config the customer config object used to process the provider object
 * @param {boolean} props.useSearchV8 the data represents search v8 data shapes
 *
 * @returns the provider content fields to render
 */
const useProviderContent = ({ provider, location, availability, config = {}, useSearchV8 = false }) => {
    const data = react_1.default.useMemo(() => {
        var _a, _b;
        if (isProviderContent(provider)) {
            if (!provider.imageUrl) {
                return Object.assign(Object.assign({}, provider), { imageUrl: (0, images_1.getProviderImageUrl)(provider) });
            }
            return provider;
        }
        else {
            const { facets = [] } = config;
            const name = (0, provider_1.getProviderDisplayName)(provider);
            const imageUrl = (0, images_1.getProviderImageUrl)(provider);
            const summaryData = useSearchV8
                ? (0, config_utils_1.getSummaryDataV8)(config)
                : (0, config_utils_1.getSummaryData)(config);
            const summaryFields = (0, provider_1.getProviderSummaryFields)(provider, summaryData, facets);
            const specialtyField = summaryFields.find((summaryField) => summaryField.field === types_1.SummaryField.SPECIALTY_V8 ||
                summaryField.field === types_1.SummaryField.SPECIALTY);
            const specialties = (specialtyField === null || specialtyField === void 0 ? void 0 : specialtyField.values.map((value) => value.primary)) || [];
            const locationName = location === null || location === void 0 ? void 0 : location.name;
            return {
                id: provider.id,
                name,
                specialties,
                locationName,
                imageUrl,
                availableDaysFromNow: (_b = (_a = availability === null || availability === void 0 ? void 0 : availability.meta) === null || _a === void 0 ? void 0 : _a.availability_density_best) !== null && _b !== void 0 ? _b : undefined
            };
        }
    }, [provider, config, useSearchV8, availability, location === null || location === void 0 ? void 0 : location.name]);
    return data;
};
exports.useProviderContent = useProviderContent;
//# sourceMappingURL=useProviderContent.js.map